<template>
    <Transition name="fade">
        <div v-if="show" class="fullscreen-preview-overlay" @click="handleClose"> 
            <div class="fullscreen-preview-content">
                <div class="fullscreen-preview-header">
                    {{ name }}
                </div>

                <div class="fullscreen-preview-body">
                    <div class="text-14px font-800  color-#fff mb-10px flex items-center justify-between">
                        <div>
                            Intro:
                        </div>
                        <div class="bg-color flex  items-center justify-center" @click.stop="handleTranslate">
                            <div class="w-14px h-14px flex items-center justify-center" v-if="translateLoading">
                                <img src="@/assets/images/message/loading.webp" alt=""
                                    class="w-full h-full animate-spin"></img>
                            </div>
                            <div class="w-14px h-14px flex items-center justify-center" v-else>
                                <img src="@/assets/images/home/Translation_is.svg" alt="" class="w-full h-full"
                                    v-if="isTranslated">
                                <img src="@/assets/images/message/Translation.svg" alt="" class="w-full h-full" v-else>
                            </div>

                            <div class="text-12px font-500 color-#fff ml-2px"
                                :class="{ 'color-#31CA41': isTranslated }" >
                                Translate
                            </div>
                        </div>
                    </div>
                    <p v-if="isTranslated" class="fullscreen-preview-text">{{ introInfo }}</p>
                    <p v-else class="fullscreen-preview-text">
                        {{ intro || 'No Intro yet. Chat and find out by yourself. ' }}
                    </p>
                </div>

                <div class="absolute bottom-3% right-50% transform translate-x-50%" @click="handleClose">
                    <img src="@/assets/images/message/close.svg" class="w-24px h-24px" alt="close" />
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useChatStore } from '@/stores/chat'
import { useLanguage } from '@/utils/language'
import { MessageAPI } from '@/services/message'
interface Props {
    show: boolean
    name?: string
    intro?: string
    isShowFree?:boolean
}

const props = withDefaults(defineProps<Props>(), {
    show: false,
    name: '',
    intro: '',
    isShowFree:false
})
const chatStore = useChatStore()

const { shortLang } = useLanguage()
const isTranslated = ref(false)
const translateLoading = ref(false)
const introInfo = ref('')

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
}>()

const handleClose = () => {
    emit('update:show', false)
}

const handleTranslate = async () => {
    if (introInfo.value) {
        isTranslated.value = false
        introInfo.value = ''
        return
    }
    translateLoading.value = true

    const res = await MessageAPI.translate({
        content: props.intro,
        src: 'auto',
        to: shortLang.value
    })
    if (res?.data) {
        introInfo.value = res.data
        isTranslated.value = true
    }
    translateLoading.value = false
}
</script>

<style scoped lang="scss">
// 全屏预览弹窗样式
.fullscreen-preview-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fullscreen-preview-content {
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    overflow: hidden;
}

.fullscreen-preview-header {
    margin: 0 auto;
    margin-top: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 24px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    max-width: 92%;
}

.fullscreen-preview-body {
    padding: 24px;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.fullscreen-preview-text {
    color: #EDF4FF;
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    max-height: 68vh;
    overflow-y: auto;
}

// 渐入渐出动画
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.bg-color {
    background: rgba(255, 255, 255, 0.1);
    // border-radius: 50%;
    padding: 3px;
    border-radius: 20px;
}
</style>
